/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * Generated by vite-plugins/prodeng-routes.ts
 * Source: content/prodeng/2026-02-06_managing-for-product-engineering-output.md
 */

import { createFileRoute } from '@tanstack/react-router';
import { ProdEngArticleLayout } from '@/components/ProdEngArticleLayout';
import { createArticleMeta } from '@/lib/meta';
import Content from '@/content/prodeng/managing-for-product-engineering-output.mdx';

const metadata = {
  title: "Managing Product Engineers: Autonomy + Visibility",
  date: "2026-02-06",
  author: "Christian Battaglia",
  articleNumber: 5,
  seoDescription: "High autonomy without losing visibility. Learn how async check-ins and 1-10 scales enable product engineering output without micromanagement.",
  linkedinUrl: "https://www.linkedin.com/pulse/managing-product-engineering-output-high-autonomy-christian-battaglia-aripe",
  heroImage: "/prodeng/managing-for-product-engineering-output.webp",
  readTime: "12 min read",
  tags: ["product engineering","engineering management","autonomy","visibility","1:1s","software engineering","leadership","productivity"],
  published: true,
};

export const Route = createFileRoute('/prodeng/articles/managing-for-product-engineering-output')({
  component: ArticlePage,
  head: () => createArticleMeta({
    title: `${metadata.title} — Product Engineering`,
    description: metadata.seoDescription || '',
    path: '/prodeng/articles/managing-for-product-engineering-output',
    image: '/og/prodeng/managing-for-product-engineering-output.png',
    imageAlt: metadata.title,
    datePublished: metadata.date,
    authorName: metadata.author,
    readTime: metadata.readTime,
    tags: metadata.tags,
    section: 'Product Engineering',
  }),
});

function ArticlePage() {
  return (
    <ProdEngArticleLayout {...metadata}>
      <Content />
    </ProdEngArticleLayout>
  );
}
